export const SET_ENTITY = "SET_ENTITY";
export const SET_COMMENTS = "SET_COMMENTS";
